<div class="popup__wrap">
  <div class="popup">
    <div class="notyfikacje notyfikacje--nie-udalo-sie">


      <div class="notyfikacje__item notyfikacje__item--nie-udalo-sie">

        <div class="notyfikacje-1__animation">
          <img src="/assets/img/tadek-nie-udalo-sie.svg" alt="" class="tadek-2 tadek-2--nie-udalo-sie">
        </div>
        <h3>
          Spróbuj jutro
        </h3>

        <p class="notyfikacje__item__paragraph-1" (click)="onClose_click()">Kliknij, aby przejść dalej</p>
      </div>


    </div>
  </div>
</div>
